import { MAX_DIMENSION_TILT, useImageAnnotatorContext } from "@msuite/image-annotator";
import type { DimensionAnnotation } from "@msuite/utils/types";
import { useTranslation } from "../../../localization";
import { Slider } from "../../../slider";

export function AnnotationToolbarSubMenuTilt() {
	/** Context */
	const context = useImageAnnotatorContext();
	const selectedAnnotation = context.controller.getSelectedAnnotation() as DimensionAnnotation;

	/** Hooks */
	const { t } = useTranslation();

	/** Guard */
	if (!selectedAnnotation) return null;

	/** Render */
	return (
		<div className="flex flex-col gap-1">
			<div className="flex flex-row justify-between items-center **:text-white! text-xs">
				<p>{t("image_annotator.tilt")}</p>
				<p>{(selectedAnnotation.tilt ?? 0).toFixed(0)}°</p>
			</div>
			<Slider
				className="w-full"
				min={-MAX_DIMENSION_TILT}
				max={MAX_DIMENSION_TILT}
				value={[selectedAnnotation.tilt ?? 0]}
				onChange={([value]) => context.controller.handleOnUpdateSelection({ tilt: value })}
			/>
		</div>
	);
}
